module.exports = __webpack_public_path__ + "static/images/deliverToSavedPOI.3pJ5b4h.svg";